import { Link } from 'react-router-dom';

import Flex from 'shared/layout/Flex';
import back from 'shared/static/images/back.svg';
import styled from 'styled-components';

import { transitionFast } from '@utils/transitions';

import LabelText from './LabelText';

export default function Back({ state, to, text, disabled = false }) {
  const el = (
    <Flex alignItems="center">
      <img src={back} style={{ marginRight: 16, height: 16, width: 10 }} alt="Go back" />
      <LabelText>{text}</LabelText>
    </Flex>
  );
  if (disabled) return el;
  return (
    <BackLink to={to} state={state}>
      {el}
    </BackLink>
  );
}

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;

  img {
    transition: ${transitionFast('transform')};
  }

  span {
    transition: ${transitionFast('color')};
  }

  :hover {
    img {
      transform: translateX(-4px);
    }

    span {
      color: ${(p) => p.theme.headingHoverColor};
    }
  }
`;
